<template>
  <div class="card-picture" :class="classNames" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
class CardPicture extends Vue {
  @Prop({
    type: String
  }) design

  @Prop({
    type: String
  }) game

  @Prop(Boolean) inactive
  @Prop(Boolean) preview
  @Prop(Boolean) hovering
  @Prop(Boolean) selected

  get classNames () {
    return {
      [`card-picture__${this.design}`]: this.design,
      [`card-picture__${this.game}`]: this.game,
      'card-picture__preview': this.preview,
      'card-picture__inactive': this.inactive,
      'card-picture__hovering': this.hovering,
      'card-picture__blank': !this.design,
      'card-picture__selected': this.selected
    }
  }
}
export default CardPicture
</script>

<style lang="scss" src="./styles/card-picture.scss"></style>
